import { ContentRoute,RouteSlotInput  } from '@caritas/ui';

import { mapImage } from '../Image.mappers';
import { hasImage } from './ContentPageHeader.mappers';

export function mapQuote(
  input: BlockQuoteFragment,
): RouteSlotInput<typeof ContentRoute, 'body', 'blockquote'> {
  const image = hasImage(input.media) ? input.media.image : undefined;
  return {
    key: 'blockquote',
    input: () => [
      {
        Image:
          image &&
          mapImage({
            image,
            preset: 'quote',
            caption: input.media?.caption,
          }),
        blockquote: input.quote,
        name: input.name,
        jobPosition: input.role,
      },
      200,
    ],
  };
}
